import { render, staticRenderFns } from "./TermsAndCondition.vue?vue&type=template&id=b92a549a&scoped=true"
import script from "./TermsAndCondition.vue?vue&type=script&lang=js"
export * from "./TermsAndCondition.vue?vue&type=script&lang=js"
import style0 from "./TermsAndCondition.vue?vue&type=style&index=0&id=b92a549a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b92a549a",
  null
  
)

export default component.exports